"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const autobind_decorator_1 = require("autobind-decorator");
const React = require("react");
const TimezonePicker = require("react-timezone");
let TimezoneComponent = class TimezoneComponent extends React.Component {
    constructor(props) {
        super(props);
        this.handleTimezoneChange = (timezone) => {
            this.setState({ timezone });
            this.props.modelChanged(this.props.field, timezone);
        };
        const timezone = props.currentModel || "Asia/Kolkata";
        this.state = {
            timezone: timezone
        };
    }
    render() {
        return (React.createElement("div", { style: { display: "flex", flexDirection: "column", marginLeft: "4px" } },
            React.createElement("label", { style: { fontSize: "10px", marginRight: "10px" } }, "ZONE"),
            React.createElement(TimezonePicker.default, { value: this.state.timezone, onChange: this.handleTimezoneChange, inputProps: {
                    placeholder: "Select Timezone...",
                    name: "timezone",
                    className: "height-resize"
                }, className: "font-resize" })));
    }
};
TimezoneComponent = __decorate([
    autobind_decorator_1.default
], TimezoneComponent);
exports.TimezoneComponent = TimezoneComponent;
//# sourceMappingURL=TimezoneComponent.js.map